import React from 'react';
import { TranslateHTML } from 'core/translate';
import { withNotifications } from '../../../common/notifications/NotificationsContext';
import { Dagger } from '../../../common/notifications/NotificationsTrigger';
import DisclaimerContainer from './DisclaimerContainer';

const HighlightWithDisclaimer = (props) => {
  const { className, value, description, disclaimer, notifications } = props;
  const { disabled } = notifications;

  const symbol = !disabled && <Dagger className={`${className}--disclaimer`} />;

  const content = (
    <div className={className}>
      <TranslateHTML value={value} description={description} />
      {disclaimer ? (
        <DisclaimerContainer {...props}>{symbol}</DisclaimerContainer>
      ) : null}
    </div>
  );

  return content;
};

export default withNotifications(HighlightWithDisclaimer);
